import Template from "@/components/Navbar/Navbar.template.vue";
import { policyList } from "@/enums/permissions";
import { LandingItem } from "@/interfaces/landingItem";
import { App, Service } from "@/interfaces/roles";
import { User } from "@/vuex/auth/types";
import { BooleanCheck } from "helix-vue-components";
import { Component, Vue } from "vue-property-decorator";
import { Getter, State } from "vuex-class";
import AppsComponent from "./Apps/Apps.component";
import ProfileComponent from "./Profile/Profile.component";

const namespace = "authModule";
@Component({
  mixins: [Template],
  components: { AppsComponent, ProfileComponent },
  name: "navbar"
})
export default class Navbar extends Vue {
  @Getter("isLogged", { namespace }) public isLogged!: string;
  public permissions!: object;
  @Getter("user", { namespace }) public user!: User;
  @Getter("services", { namespace })
  public services!: Service[];
  @Getter("hasPermission", { namespace }) public hasPermission!: BooleanCheck;
  @State("appVersion") public appVersion!: string;
  public fullScreenAction: boolean = false;
  public policyList = policyList;
  public environment = "";

  public apps: App[] = [
    {
      title: "biotrack",
      image: require("@/assets/images/app_brand_bioTrackTHC.svg"),
      path: process.env.VUE_APP_DISPENSARY_FRONT,
      app: "bdi"
    },
    {
      title: "helix_technologies",
      image: require("@/assets/images/app_brand_helix_technologies.svg"),
      path: process.env.VUE_APP_CORE_FRONTEND,
      app: "core"
    },
    {
      title: "cannalytics",
      image: require("@/assets/images/app_brand_cannalytics.svg"),
      path:
        process.env.VUE_APP_CANNALYTICS_FRONT ||
        "https://apps.helixcannalytics.com/accounts/user_login/",
      app: "cnl"
    }
  ];
  public setLandingOptions() {
    const landingOption: LandingItem[] = [
      {
        namedRoute: "permission-management-list",
        icon: "fa-user-friends",
        translationString: "permission_management",
        permission: ""
      },
      {
        namedRoute: "location-management-list",
        icon: "fa-building",
        translationString: "location.location_management",
        permission: policyList.viewLocations
      },
      {
        namedRoute: "user-management-list",
        icon: "fa-user",
        translationString: "user_management",
        permission: policyList.viewUsers
      },
      {
        namedRoute: "location-api-management",
        icon: "fa-puzzle-piece",
        translationString: "loc-api.title",
        permission: ""
      }
    ];
    return landingOption;
  }

  public get items(): object[] {
    const items = [];
    const myApps: string[] = ["cnb", "cnl"];
    this.services.forEach(service => myApps.push(String(service.id)));
    for (const app of this.apps) {
      if (myApps.includes(app.app)) {
        if (app.app !== "core") {
          items.push({ ...app, isLive: true });
        }
      } else {
        items.push({ ...app, isLive: false });
      }
    }
    return items;
  }

  public mounted() {
    const host = process.env.VUE_APP_CORE_ENVIROMENT;
    if (!(host === "product")) {
      this.environment = host;
    }
  }
  public toggleFullscreen() {
    this.fullScreenAction = !this.fullScreenAction;
    this.$emit("fullscreenToggled");
  }

  public isAllowed(policy: string): boolean {
    if (policy) {
      return this.hasPermission(policy);
    }
    return true;
  }
  public actionList(route: string) {
    this.$router.push({
      name: route
    });
  }
}
